import Dinero from 'dinero.js';
var ShippingRate = /** @class */ (function () {
    function ShippingRate() {
    }
    ShippingRate.prototype.toApi = function () {
        return {
            mailClass: this.mailClass,
            mailService: this.mailService,
            totalPrice: this.totalPrice.getAmount(),
            deliveryTimeInDays: this.deliveryTimeInDays,
        };
    };
    ShippingRate.createFromApi = function (dto) {
        return Object.assign(new ShippingRate(), dto, {
            totalPrice: Dinero({ amount: Math.round(dto.totalPrice * 10000), currency: "USD", precision: 4 }),
        });
    };
    return ShippingRate;
}());
export { ShippingRate };
